module.exports = __webpack_public_path__ + "static/media/phoenixrehoming.d16f5d7d.png";